import { createInteriorRoomCalculator } from "./interior-room-shared.js";

/**
 * Mudroom (Phase 13A). No trim category (not typical scope here), but
 * does include windows/doors since an exterior door is commonly replaced
 * as part of a mudroom renovation. Its unique addition is heated flooring
 * - priced per sqft (unlike this batch's other boolean features, which
 * are flat allowances) since heated-floor cost genuinely scales with the
 * room's footprint.
 */
export const calculateMudroom = createInteriorRoomCalculator({
  projectType: "mudroom",
  anchorItemId: "mudroom_base_renovation",
  tierFeatures: [
    {
      answerKey: "mudroom_flooring_type",
      itemIdByTier: { not_changing: null, basic: "mudroom_flooring_basic", mid_range: "mudroom_flooring_mid", premium: "mudroom_flooring_premium" },
      quantityFromSqft: true,
      excludedMessage: "Flooring is not changing - excluded from this estimate."
    },
    {
      answerKey: "mudroom_painting",
      itemIdByTier: { not_included: null, walls_only: "mudroom_painting_walls", full_room: "mudroom_painting_full" },
      quantityFromSqft: true,
      excludedMessage: "Painting was not included - excluded from this estimate."
    },
    {
      answerKey: "mudroom_lighting",
      itemIdByTier: { keep_existing: null, standard_swap: "mudroom_lighting_standard", statement_lighting: "mudroom_lighting_statement" },
      excludedMessage: "Lighting is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "mudroom_built_ins",
      itemIdByTier: { none: null, standard: "mudroom_built_ins_standard", custom: "mudroom_built_ins_custom" },
      excludedMessage: "No bench/lockers/cubby built-ins were requested - excluded from this estimate."
    },
    {
      answerKey: "mudroom_windows_doors",
      itemIdByTier: { none: null, replace_existing: "mudroom_windows_doors_replace", add_new: "mudroom_windows_doors_add" },
      excludedMessage: "No exterior door/window changes were requested - excluded from this estimate."
    }
  ],
  booleanFeatures: [
    { answerKey: "mudroom_heated_floor", itemId: "mudroom_heated_floor", quantityFromSqft: true, excludedMessage: "In-floor heating was not requested - excluded from this estimate." }
  ],
  electricalItemId: "mudroom_electrical",
  demolitionItemId: "mudroom_demolition",
  accessibilityItemId: "mudroom_accessibility",
  permitDesignItemId: "mudroom_permit_design"
});
